// extracted by mini-css-extract-plugin
export var song = "SongList-module--song--F4EyX";
export var songs = "SongList-module--songs--oAtk0";